import { formatCurrency } from '../config/resources/utils'
import { supabaseGestionPension as supabase } from '../config/settings/supabase-client'
import { getLogger } from '../core/debuggers'
import { getCurrentUtm, mapUtmFromDb } from '../mappers/utm.mapper'
import { fetchLatestImm } from './onboarding'

const logger = getLogger('indicators.js')

/**
 * Current UTM (calendar month) + latest IMM for public/login surfaces.
 * @returns {Promise<{
 *   utm: { value: string, rawValue: number, period: string } | null,
 *   imm: { value: string, rawValue: number, effectiveFrom: string | null } | null,
 * }>}
 */
export async function fetchCurrentIndicators() {
  try {
    const [{ data: utmRows, error: utmError }, imm] = await Promise.all([
      supabase
        .from('utm_history')
        .select('id, value, source, retrieved_at, target_month')
        .order('target_month', { ascending: false })
        .limit(24),
      fetchLatestImm().catch(() => null),
    ])

    if (utmError) {
      logger.error('fetchCurrentIndicators utm error:', utmError)
    }

    const utms = (utmRows || []).map(mapUtmFromDb)
    const currentUtm = getCurrentUtm(utms)

    return {
      utm: currentUtm
        ? {
            value: currentUtm.value,
            rawValue: currentUtm.rawValue,
            period: `${currentUtm.targetMonth} ${currentUtm.targetYear}`,
          }
        : null,
      imm: imm
        ? {
            value: formatCurrency(imm.value),
            rawValue: imm.value,
            effectiveFrom: imm.effectiveFrom || null,
          }
        : null,
    }
  } catch (error) {
    logger.error('fetchCurrentIndicators error:', error)
    return { utm: null, imm: null }
  }
}
